import { Chart, Plugin } from 'chart.js';

export type VerticalLinePluginOptions = {
  color?: string;
};

export const verticalLinePlugin = (
  options?: VerticalLinePluginOptions,
): Plugin => ({
  id: 'draw-vertical-line',
  afterDraw: (chart: Chart) => {
    if (!chart.tooltip) {
      return;
    }

    const activeElements = chart.tooltip.getActiveElements();

    if (activeElements.length > 0) {
      const x = activeElements[0].element.x;
      const yAxis = chart.scales['y'];
      const ctx = chart.ctx;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, yAxis.top);
      ctx.lineTo(x, yAxis.bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = options?.color ?? '#000000';
      ctx.stroke();
      ctx.restore();
    }
  },
});
